import { getRuntimeConfig } from 'api/taxi.rest.backend';
import { setRuntimeConfig } from './actions';
import { SHORT_ENV } from '../../utils/constants';
import { setUpDDLogging, setUpDDRUM } from '../../utils/log.utils';

export async function getRuntimeConfigOnStartup(dispatch) {
  try {
    const rtc = await getRuntimeConfig();
    setUpDDLogging(SHORT_ENV[rtc.DEPLOYMENT_ENVIRONMENT]);
    setUpDDRUM(SHORT_ENV[rtc.DEPLOYMENT_ENVIRONMENT]);
    dispatch(setRuntimeConfig(rtc));
  } catch (e) {
    console.log(e); // eslint-disable-line no-console
  }
}
